import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { passwordStrength } from 'check-password-strength';
import { PasswordProps } from './types';

export function usePassword<
	T extends { password: string; confirmpassword: string }
>({ formik }: PasswordProps<T>) {
	const { formatMessage } = useIntl();
	const [showPassword, setShowPassword] = useState(false);
	const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

	const [strenghOfPassword, setStrenghOfPassword] = useState('');
	const [textOfStrengthOfPassword, setTextOfStrengthOfPassword] =
		useState<String | null>(null);
	const STRONG_TEXT_PASSWORD = {
		'Too weak': 'AUTH.PASSWORD.METER.TOOWEAK',
		Weak: 'AUTH.PASSWORD.METER.WEAK',
		Medium: 'AUTH.PASSWORD.METER.MEDIUM',
		Strong: 'AUTH.PASSWORD.METER.STRONG',
	};
	const checkPasswordStrength = (password: string) => {
		const strength = passwordStrength(formik.values.password).value;
		setStrenghOfPassword(strength);
		const text =
			STRONG_TEXT_PASSWORD[strength as keyof typeof STRONG_TEXT_PASSWORD];
		setTextOfStrengthOfPassword(formatMessage({ id: text }));
	};

	useEffect(() => {
		if (formik.values.password.length > 0) {
			checkPasswordStrength(formik.values.password);
		} else {
			setStrenghOfPassword('');
			setTextOfStrengthOfPassword(null);
		}
	}, [[formik.values.password.length, strenghOfPassword]]);

	return {
		formatMessage,
		showPassword,
		setShowPassword,
		strenghOfPassword,
		setStrenghOfPassword,
		STRONG_TEXT_PASSWORD,
		textOfStrengthOfPassword,
		setTextOfStrengthOfPassword,
		showPasswordConfirm,
		setShowPasswordConfirm,
	};
}
